module.exports = __webpack_public_path__ + "img/W-31.e1d36f3a.jpg";